import { GafOktaBrowser, GafOktaCallbacks, WindowLocation } from "@gaf/typescript-authentication-okta";
import * as CONFIG from "../../config.json";
import { GafAuthenticationMode } from "@gaf/typescript-authentication-general";
import { GafOktaSettings } from "@gaf/typescript-authentication-okta";
import { GafTokenManager, GafStorageManagerSession } from "@gaf/typescript-authentication-general";
import { getQueryString } from '../utils/utils';
// const urlParams = new URLSearchParams(window.location.search);
// const provider = urlParams.get("provider");

const provider =
    getQueryString("provider", window.location.href) ||
    getQueryString("provider", sessionStorage.getItem("requestURL"));
const urlProvider = provider && provider.toLowerCase();

export const callbacks = {
    getScopesKeyFromUrl: (url) => "audience",
};

export const API_CUSTOM_SCOPES = [
    //  'openid',
    //  'email',
    //  'token',
    //  "application:getapplicationcontext"
    "Warranty:GetWarranties",
    "Warranty:UpdateWarranty",
    "Warranty:CancelWarranty",
    "Warranty:CreateWarranty",
    "Warranty:DeleteWarranty",
    "Warranty:GetWarrantyById",
    "Warranty:GetSubmittedWarrantyById",
    "Warranty:ReSubmitWarranty",
    "Warranty:IsPriceChanged",
    "Warranty:GetProductAccessories",
    "Warranty:GetWarrantyData",
    "Warranty:Review",
    "Warranty:ReviewFormData",
    "Contractor:GetContractorDetails",
    "Contractor:SearchContractors",
    "Contractor:GetUserProfile",
    "FormLayout:GetFormLayoutSchema",
    "FormLayout:GetFormLayoutSchemaByFormType",
    "FormLayout:ValidateFormData",
    "Payment:ValidateTransaction",
    "Payment:BeginTransaction",
    "Template:GetTemplates",
    "Template:GetById",
    "Template:Savetemplate",
    "Template:DeleteTemplateList",
    "Warranty:GetWarrantiesReport",
    "Warranty:GenerateReport",
    "Warranty:WarrantiesMonthlyReport",
    "FormLayout:Write",
    "Warranty:SuperAdmin",
    "ShoppingCart:Write",
    "ShoppingCart:Read",
];

const Auth0idp = CONFIG.OKTA_CONFIG.Auth0idp;
const Oktaidp = CONFIG.OKTA_CONFIG.Oktaidp;

CONFIG.OKTA_CONFIG["instrumentationKey"] = CONFIG.CONFIG.instrumentationKey;
CONFIG.OKTA_CONFIG["scopes"] = API_CUSTOM_SCOPES;
CONFIG.OKTA_CONFIG["mode"] = GafAuthenticationMode.Parent;
CONFIG.OKTA_CONFIG["idp"] = CONFIG.USE_AUTH0_IDP ? Auth0idp : undefined;
CONFIG.OKTA_CONFIG["postLogoutRedirectUri"] = CONFIG.USE_AUTH0_IDP ? CONFIG.OKTA_CONFIG.postLogoutRedirectUri : CONFIG.OKTA_CONFIG.loginUrl;

const OKTA_CONFIGURATION = CONFIG.OKTA_CONFIG as GafOktaSettings;

export const GafOktaManager = new GafOktaBrowser(
    OKTA_CONFIGURATION,
    callbacks,
    new GafTokenManager(),
    new GafStorageManagerSession(),
    new WindowLocation()
);

/*  In updated version it's taking care automatically to renew token.
 * we don't need below method for now.
 * We might need it while adding the scopes
 */
/*export const ScheduleRenewal = () => {
 {
    const accessToken = JSON.parse(
      sessionStorage.getItem("okta-token-storage")
    );

    if (
      accessToken != null &&
      accessToken.accessToken !== undefined &&
      accessToken.accessToken.expiresAt !== undefined
    ) {
      let expireDateTime = accessToken.accessToken.expiresAt * 1000;
      let currentDateTime = new Date().getTime();
      let diffDateTime = (currentDateTime - expireDateTime) * -1;

      setTimeout(() => {
        //check the token value, if token is still active or not. If it's not this method will redirect to login screen.
        GafOktaManager.getRenewToken();
      }, diffDateTime);
    }
  }
};*/
